<template>
  <div class="tm-detail-overlay tm-detail-overlay--schmal"
      :style="dragStyle"
      @pointermove="ziehenBewegen"
      @pointerup="ziehenEnde"
      @pointercancel="ziehenEnde"
    >
    <div class="tm-sheet-griff" @pointerdown="ziehenStart">
      <div class="tm-sheet-griff-inner"></div>
      <button type="button" class="tm-sheet-griff__schliessen" aria-label="Schließen" @pointerdown.stop @click="$emit('close')">✕</button>
    </div>
    <div class="tm-detail-overlay__kopf">
      <div class="tm-tabelle__kopf-info">
        <img v-if="match.ligaLogo" :src="match.ligaLogo" class="tm-tabelle__liga-logo" alt="" />
        <div class="tm-tabelle__kopf-texte">
          <span class="tm-tabelle__kopf-label">Tabelle</span>
          <span class="tm-tabelle__kopf-liga">{{ match.liga }}</span>
        </div>
      </div>
    </div>

    <div class="tm-detail-overlay__inhalt tm-detail-overlay__inhalt--einfach" v-scroll-melden>
      <div v-if="tabelleLaedt" class="tm-state"><span class="tm-state__spinner"></span> Lade Tabelle...</div>
      <div v-else-if="tabelleFehler" class="tm-state tm-state--error">{{ tabelleFehler }}</div>
      <TabelleContent v-else :tabellen="effektiveTabellen" :match="match" />
    </div>
  </div>
</template>

<script setup>
import { ref, computed, watch } from 'vue'
import { useSheetDrag } from '../composables/useSheetDrag.js'
import TabelleContent from './TabelleContent.vue'
import { vScrollMelden } from '../lib/scrollLock.js'
import { ladeTabelleFuerLiga } from '../lib/matchLookup.js'
import { tabelleFuerLiga } from '../lib/standings.js'

const props = defineProps({
  tabellen: { type: Array, required: true },
  match: { type: Object, required: true },
  // GEÄNDERT: neu - wird gebraucht, seit MatchCard.vue's Tabellen-Button auch bei Ligen zeigt,
  // die NICHT im vorab geladenen tabellen-Array stecken (siehe hatTabelle-Fix dort) - für diese
  // Fälle muss hier lazy nachgeladen werden, statt einfach eine leere/kaputte Ansicht zu zeigen.
  apiBase: { type: String, default: '/rest/courseservice/oddsservice/free' }
})
const emit = defineEmits(['close'])

const { ziehenStart, ziehenBewegen, ziehenEnde, dragStyle } = useSheetDrag(() => emit('close'))

// Gleiches Muster wie in DetailOverlay.vue's Tabellen-Tab: fehlt die Liga im vorab geladenen
// tabellen-Array (Prop), einzeln per ligaId nachladen (gecacht in matchLookup.js, mehrere
// Aufrufer derselben Liga teilen sich den Request).
const tabelleLazyGeladen = ref([])
const tabelleLaedt = ref(false)
const tabelleFehler = ref(null)

const effektiveTabellen = computed(() => {
  const ausProp = tabelleFuerLiga(props.tabellen, props.match.ligaId)
  return ausProp.length > 0 ? props.tabellen : tabelleLazyGeladen.value
})

watch(() => props.match.ligaId, async () => {
  if (tabelleFuerLiga(props.tabellen, props.match.ligaId).length > 0) return // schon über Prop da
  if (tabelleFuerLiga(tabelleLazyGeladen.value, props.match.ligaId).length > 0) return // schon lazy geladen
  if (props.match.ligaId == null) return

  tabelleLaedt.value = true
  tabelleFehler.value = null
  try {
    tabelleLazyGeladen.value = await ladeTabelleFuerLiga(props.apiBase, props.match.ligaId)
  } catch (e) {
    tabelleFehler.value = 'Tabelle konnte nicht geladen werden.'
    console.warn('ladeTabelleFuerLiga fehlgeschlagen:', e)
  } finally {
    tabelleLaedt.value = false
  }
}, { immediate: true })
</script>